import React, { FC, Fragment, useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, } from '@fortawesome/free-solid-svg-icons';
import { MainContext } from '../contexts/MainContext';
import { Accessibility, } from '@bepro-travel/fe.shared';
import { useTranslation } from 'react-i18next';

interface HeaderProps {
  notOpenTabWithChildren?: boolean;
}

const Header: FC<HeaderProps> = (props) => {
  const { t } = useTranslation();
  const { header } = useContext(MainContext);
  const [hamburgerState, setHamburgerState] = useState(false);
  const [isHoverElement, setIsHoverElement] = useState(-2);
  const navigate = useNavigate();

  const onPressHanburger = () => {
    document.querySelector('.header-fields')!.classList.toggle('open');
    setHamburgerState(!hamburgerState);
  };

  const closeMenu = (event?: any, index?: number) => {
    if (window.screen.width < 768) {
      if (event && ['path', 'svg'].includes(event.target.tagName)) {
        setIsHoverElement(typeof index === 'number' ? index : -2);
      } else {
        document.querySelector('.header-fields')!.classList.remove('open');
        setHamburgerState(false);
      }
    }
  };

  const onClickHeaderCell = (event?: any, item?: any) => {
    if (props.notOpenTabWithChildren && item?.subPages.length) {
      return;
    }

    if (window.innerWidth < 768) {
      closeMenu(event);
    }
    let url = '';

    if (item && item.routeName === 'Pages') {
      url = item.routeName + '/' + item.url;
    }

    if (event.target.tagName.toLowerCase() === 'a') {
      document.querySelector('.header-fields')!.classList.remove('open');
      setHamburgerState(false);
      return;
    }

    navigate(url);
  };


  return (
    <Fragment>
      <div className="header">
        <Link className="header-logo-wr" to="/">
          <img className="header-logo" src={require('../assets/img/logo.png')} alt="Logo" />
        </Link>

        <span className="hamburger">
          <input
            id="hamburger__toggle"
            type="checkbox"
            onChange={onPressHanburger}
            checked={hamburgerState}
          />
          <label className="hamburger__btn" htmlFor="hamburger__toggle">
            <span></span>
          </label>
        </span>
        <div className="header-fields">
          {header?.siteMenu?.mainPages.map((item, index) => (
            <div
              className="header-cell"
              key={index}
              onMouseLeave={() => setIsHoverElement(-2)}
              onMouseEnter={() => setIsHoverElement(index)}
            >
              <span
                className="header-cell-text"
                onClick={(event) => onClickHeaderCell(event, item)}
              >
                {item.titleLang.ru}
                {!!item.subPages.length && <FontAwesomeIcon icon={faChevronDown as any} />}
              </span>

              {!!item.subPages.length && (
                <div
                  className={
                    'header-dropdown header-dropdown-sm' + (isHoverElement === index ? ' open' : '')
                  }
                >
                  {item.subPages
                    .sort((a, b) => {
                      if (a.orderDisplay !== b.orderDisplay) {
                        return a.orderDisplay - b.orderDisplay;
                      }

                      return a.titleLang?.ru?.localeCompare(b.titleLang?.ru);
                    })
                    .map((subItem, subIndex) => (
                      <div className="header-dropdown-row" key={subIndex}>
                        <Link
                          to={subItem.routeName + '/' + subItem.url}
                          key={subIndex}
                          onClick={() => closeMenu()}
                        >
                          {subItem.titleLang.ru || subItem.titleLang.he}
                        </Link>
                      </div>
                    ))}
                </div>
              )}
            </div>
          ))}
          <div className="header-cell">
            <Link
              className="header-cell-text"
              to="/guides"
              onClick={() => closeMenu()}
            >
              Гиды
            </Link>
          </div>
        </div>
        <Accessibility />
      </div>
    </Fragment >
  );
};

export default Header;
